<template>
  <div>
    <div class="login">
      <div class="user-top">
        <mu-icon @click="goback" value="arrow_back"></mu-icon>
        <a @click="toRegister" style="padding-right:10px;color:#1882d4;">注册</a>
      </div>
      <dl class="user-title">
        <dt class='logoicon'>
          <img :src="this.$store.state.login_logo"  style="height:70%;width:auto;padding-left:10px;"/>
          <!-- <div style="font-size:1.5rem;padding:10px;">COINKE</div> -->
        </dt>
        <dd style="font-size:1.2rem; color:gray;padding:10px 0px;">登录{{this.$store.state.appname}}</dd>
      </dl>

      <div class="user-form">
        <mu-text-field
          max-length="12"
          min-length="6"
          full-width
          v-model="phone"
          placeholder="账号ID"
        ></mu-text-field>
        <mu-text-field
          min-length="6"
          full-width
          v-model="password"
          type="password"
          placeholder="密码"
        ></mu-text-field>
        <br />
        <br />
        <mu-button @click="login" color="primary" :disabled="!canLogin" full-width>登录</mu-button>
        <br>
          <span v-if="!user" class='loginclass'>需要帮助？<a @click="toHelp">在线客服</a></span>
      </div>
    </div>
  </div>
</template>

<script>
import Api from "@/api";
import Util from '@/utils'
export default {
  data() {
    return {
      phone: "",
      password: ""
    };
  },
  computed: {
    canLogin() {
      return this.phone.length >5 && this.password.length >5;
    }
  },
  methods: {
    toRegister() {
      this.$router.push("/register");
    },
    toHelp() {
      this.$router.push("/kefu");
      //window.toService();
    },
    login() {
      if (!this.phone) {
        this.$toast("请输入账户ID");
        return;
      }
      if (!this.password) {
        this.$toast("请输入密码");
        return;
      }
      this.$indicator.open({
        text: "提交中...",
        spinnerType: "fading-circle"
      });
      Api.login(this.phone, this.password).then(res => {
        if (!res.data.hasOwnProperty("error")) {
          this.$store.state.user = res.data.user;
          window.token = res.data.token;
          Util.setToken(window.token);
          this.$toast("登录成功");
          this.$router.replace("/");
        } else {
          this.$toast(res.data.error);
        }
        this.$indicator.close();
      });
    },
    goback() {
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped>
.user-top {
  display: flex;
  justify-content: space-between;
  padding: 20px 20px;
  align-items: center;
}
.user-title {
  padding: 30px 10px;
  width: 100%;
  text-align: left;
}
.user-form {
  display: flex;
  padding: 10px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.myinput {
  height: 50px;
  width: 80%;
  border: gray;
}
.logoicon{
    background: #2196f3;
    height: 60px;
    width: 100vw;
    display: flex;
    align-items: center;
    color: white;
}
</style>>

</style>


// WEBPACK FOOTER //
// src/pages/LoginByIcode.vue